import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthStoreService } from '@rms/auth';
import { environment } from '@rms/env';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const token = inject(AuthStoreService).getToken();

  if (!token || !req.url.startsWith(environment.apiEndpoint) || req.headers.has('Authorization')) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
